export default function (): string {
    return crypto.randomUUID();
}
